import { render, staticRenderFns } from "./MessageSendLog.vue?vue&type=template&id=ec5b9198&scoped=true&"
import script from "./MessageSendLog.vue?vue&type=script&lang=js&"
export * from "./MessageSendLog.vue?vue&type=script&lang=js&"
import style0 from "./MessageSendLog.vue?vue&type=style&index=0&id=ec5b9198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5b9198",
  null
  
)

export default component.exports